import type { ApplicationProvider } from '../../../App/model/application';
import type { MxApplicationService } from '../../../App/services/mx-application-service';
import type { MxActionManagerService, ActionProvider } from './mx-action-manager-service';
import type { WorkspaceLoaderService } from '../../../WorkspaceLoader/workspace-loader.service';
import type { MxNavigationService, NavigationProvider } from '../../Navigation/mx-navigation-service';
import { EventCodes } from '../../../App/model/event-codes';
import type { EventService } from '../../../App/services/event-service';

type ShellAppConfig = {
	applicationProvider?: ApplicationProvider;
	actionProvider?: ActionProvider;
	navigationProvider?: NavigationProvider;
};

export class ShellAppInitializerService {
	public static $inject = ['mx.shell.AppsService', 'mx.shell.ActionManagerService', 'mx.sb.WorkSpaceLoader.Service', 'mx.shell.NavigationService', 'mx.shell.EventService'];
	constructor(
		private readonly appsService: MxApplicationService,
		private readonly actionManagerService: MxActionManagerService,
		private readonly workspaceLoaderService: WorkspaceLoaderService,
		private readonly navigationService: MxNavigationService,
		private readonly eventService: EventService
	) {}

	public async initShellApp({ applicationProvider, actionProvider, navigationProvider }: ShellAppConfig) {
		this.appsService.setApplicationProvider(applicationProvider);
		this.actionManagerService.setActionProvider(actionProvider);
		this.navigationService.setNavigationProvider(navigationProvider);

		await this.workspaceLoaderService.loadWorkspaces();

		this.eventService.dispatchEvent(EventCodes.ShellAppInitialized);
	}
}
